export default "<iframe id=\"0extrnlresponseIFrame\" [src]=\"iframeSrcURL | safeUrl\" width=\"100%\" height=\"600\" class=\"air-viewer\"></iframe>\r\n"